'use strict';

var CompetitorFaresChartDirective = function CompetitorFaresChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/competitor-fares-chart.html'),
    controller: 'CompetitorFaresChartController',
    scope: {
      screen: '@',
      mode: '@',
      visible: '=',
      metrics: '=',
      isExpandedModeEnabled: '=',
      primaryEntity: '=',
      chartData: '=',
      legendItems: '=',
      legendItemsCallback: '=',
      filter: '=',
      quickFilterUpdatedCallback: '=',
      chartFormatters: '=',
      modeDifferFromVisible: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters, scope.isExpandedModeEnabled);
      scope.renderChartDataPresent = function (data) {
        if (scope.visible) {
          chart.withMetric('Fare').render(data, scope.chartData.verticalLineData);
        }
        scope.$emit('reload-carousel');
      };
    }
  };
};
CompetitorFaresChartDirective.$inject = ['CompetitorFaresChart'];
module.exports = CompetitorFaresChartDirective;